import { useNavigate } from 'react-router-dom';
import { t } from 'i18next';
import TradingPhotoCardItem from './TradingPhotoCardItem';
import type { SaleTradingPhotoCardType } from '../types/MarketCardType';


interface TradingPhotoCardItemListProps {
  filteredPhotoCards: SaleTradingPhotoCardType[];
  subTabIndex: number;
}

const TradingPhotoCardItemList = ({
  filteredPhotoCards,
  subTabIndex
}: TradingPhotoCardItemListProps) => {
  const navigate = useNavigate();

  const handleNavigate = () => {
    if (subTabIndex === 0) {
      navigate('/tradings/photo_cards');
    } else {
      navigate('/tradings/add_trading_photo_cards?isExchange=false');
    }
  };

  if (filteredPhotoCards.length === 0) {
    return (
      <div className="flex flex-col items-center mt-[128px] leading-none">
        <p className="h-[75px] flex items-center text-[50px]">😳</p>
        <p className="text-text-main-lv2 text-[17px] font-bold mt-[8px]">
          {t('NewTradingPhotoCardMarket.noPhotoCard', {
            category:
              subTabIndex === 0
                ? t('NewTradingPhotoCardMarket.notifications.messageCategoryPurchasing')
                : t('NewTradingPhotoCardMarket.notifications.messageCategorySelling')
          })}
        </p>
        <button
          type="button"
          className="mt-[38px] px-[18px] py-[11px] text-[14px] font-semibold text-text-main-lv2 border border-surface-lv2 bg-surface-lv1 rounded-[52px]"
          onClick={handleNavigate}
        >
          {t('NewTradingPhotoCardMarket.goToExchange')}
        </button>
      </div>
    );
  }

  return filteredPhotoCards.map((tradingPhotoCard) => (
    <TradingPhotoCardItem
      key={tradingPhotoCard.tradingPhotoCardId}
      tradingPhotoCard={tradingPhotoCard}
    />
  ));
};

export default TradingPhotoCardItemList;
